const g = typeof window === "undefined" ? global : window;
function singletonMap(name) {
  const key = `__gv_singleton_maps-${name}`;
  if (key in g) {
    return g[key];
  }
  return g[key] = {};
}
export {
  singletonMap
};
//# sourceMappingURL=SingletonMap.js.map
